import type { CzListSet } from '@/api/sap/cz-list-set'
import { createContext } from 'react'

export interface CzListSetsContextValue {
  czListSetsByCustomZone: Record<string, CzListSet>
  isLoading: boolean
  isError: boolean
}

export const CzListSetsContext = createContext<CzListSetsContextValue | null>(null)
